var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlatCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 10,
    viewBox: "0 0 88 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.145 2.288c.8.193 1.58.464 2.33.807a4.87 4.87 0 0 1 1.882 1.602l-.157.106a4.495 4.495 0 0 0-.801-.89 5.022 5.022 0 0 0-1.005-.658 11.508 11.508 0 0 0-2.295-.793l.046-.174z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m87.621 4.987-.076-.11-.098.068.077.11.097-.068zM87.533 5.204l-.077-.11-.098.068.077.11.098-.068z",
    fill: "#CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m87.469 4.617.242.348-.38.264-.242-.348a.126.126 0 0 1 .031-.176l.174-.121a.126.126 0 0 1 .175.033zM4.932 2.288c-.802.193-1.583.464-2.333.807A4.851 4.851 0 0 0 .721 4.697l.154.106c.224-.33.491-.63.794-.89.308-.258.645-.48 1.005-.658.735-.345 1.506-.61 2.297-.793l-.039-.174z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m.465 5.151.077-.11-.098-.067-.076.11.097.067zM.645 5.274l.077-.11-.098-.068-.077.11.098.068z",
    fill: "#CCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.993 4.882.75 5.23l-.38-.264.242-.349a.126.126 0 0 1 .177-.031l.174.121a.126.126 0 0 1 .031.176l-.001-.001z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.871 2.894h1.72A.407.407 0 0 0 88 2.487V1.212a.407.407 0 0 0-.407-.407H85.87a.407.407 0 0 0-.407.407v1.275c0 .225.182.407.407.407z",
    fill: "#333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.48 1.088a.355.355 0 0 1 .12-.019h1.72a.41.41 0 0 1 .41.41v1.283c-.001.04-.007.079-.017.117a.407.407 0 0 0 .286-.389V1.21a.407.407 0 0 0-.407-.407h-1.723a.406.406 0 0 0-.388.285z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m83.85 2.158 3.411.2a.303.303 0 0 0 .32-.303V1.55a.3.3 0 0 0-.32-.3l-3.411.2v.709z",
    fill: "#4D4D4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m86.53 1.726.675-.006v-.303l-.675.028v.28zM85.726 1.733l.55-.005v-.272l-.55.022v.255zM85.054 1.739l.461-.004v-.25l-.461.021v.233zM84.49 1.745l.388-.004v-.229l-.389.017v.216zM86.53 2.161l.675.028v-.305l-.675-.006v.283zM85.726 2.128l.55.022v-.273l-.55-.004v.255zM85.054 2.1l.461.019v-.25l-.461-.003V2.1zM84.49 2.078l.388.014v-.228l-.389-.002v.216zM87.463 3.09h-.217a.186.186 0 0 1-.186-.187v-.137h.59v.137a.186.186 0 0 1-.187.186zM86.486 3.09h-.223a.186.186 0 0 1-.186-.187v-.137h.597v.137a.185.185 0 0 1-.188.186zM1.26 2.676l-.732-.338a.218.218 0 0 1-.13-.201v-.579a.221.221 0 0 1 .13-.2l.733-.339v1.657z",
    fill: "#333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.26 1.019v.108l-.615.283a.25.25 0 0 0-.145.236V2.336a.225.225 0 0 1-.106-.186v-.592a.225.225 0 0 1 .128-.2l.738-.339z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1.121v1.455a.314.314 0 0 1-.315.314h-.898a.313.313 0 0 1-.213-.082.307.307 0 0 1-.104-.232V1.121a.316.316 0 0 1 .317-.318h.892a.32.32 0 0 1 .32.318z",
    fill: "#333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.585 1.047H1.468c-.17 0-.293.227-.293.485V2.81a.307.307 0 0 1-.105-.234V1.121a.316.316 0 0 1 .317-.318h.892a.313.313 0 0 1 .306.244z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m5.16 2.158-3.411.2a.303.303 0 0 1-.32-.303V1.55a.301.301 0 0 1 .32-.3l3.411.2v.709z",
    fill: "#4D4D4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m2.477 1.726-.675-.006v-.303l.675.028v.28zM3.284 1.733l-.553-.005v-.272l.553.022v.255zM3.955 1.739l-.46-.004v-.25l.46.021v.233zM4.52 1.745l-.39-.004v-.229l.39.017v.216zM2.477 2.161l-.675.028v-.305l.675-.006v.283zM3.284 2.128l-.553.022v-.273l.553-.004v.255zM3.955 2.1l-.46.019v-.25l.46-.003V2.1zM4.52 2.078l-.39.014v-.228l.39-.002v.216z",
    fill: "#333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.792 2.714h-6.673v.98h6.673v-.98z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.373 3.383H9.536a.902.902 0 0 0-.902.902v1.089c0 .498.404.902.902.902h9.838a.902.902 0 0 0 .903-.902V4.285a.902.902 0 0 0-.902-.902z",
    fill: "#333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.957 2.714h-6.673v.98h6.673v-.98z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.54 3.383h-9.838a.902.902 0 0 0-.902.902v1.089c0 .498.404.902.902.902h9.838a.902.902 0 0 0 .903-.902V4.285a.902.902 0 0 0-.903-.902z",
    fill: "#333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.895 6.402a3.008 3.008 0 1 0-5.854-1.382 3.008 3.008 0 0 0 5.855 1.382z",
    fill: "gray"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.71 6.158a2.772 2.772 0 1 0-5.47-.888 2.772 2.772 0 0 0 5.47.888z",
    fill: "#4D4D4D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.88 6.023a1.93 1.93 0 1 0-3.812-.618 1.93 1.93 0 0 0 3.812.618z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.574 5.712a.605.605 0 1 1-1.21 0 .605.605 0 0 1 1.21 0z",
    fill: "#4D4D4D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.42 8.491a3.008 3.008 0 1 0-2.302-5.558 3.008 3.008 0 0 0 2.302 5.558z",
    fill: "gray"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M81.23 7.672a2.772 2.772 0 1 0-3.92-3.92 2.772 2.772 0 0 0 3.92 3.92z",
    fill: "#4D4D4D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.635 7.077a1.93 1.93 0 1 0-2.73-2.73 1.93 1.93 0 0 0 2.73 2.73z",
    fill: "#333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.27 6.317a.605.605 0 1 0 0-1.21.605.605 0 0 0 0 1.21zM73.526 5.115h-1.834v.28h1.835v-.28zM73.526 5.616h-1.834v.279h1.835v-.28zM73.526 4.613h-1.834v.279h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m73.528 4.894-1.836.515v-.28l1.836-.516v.28z",
    fill: "gray"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.526 6.118h-1.834v.279h1.835v-.28zM73.526 6.627h-1.834v.28h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m73.528 5.394-1.836.517v-.279l1.836-.517v.28zM73.528 5.897l-1.836.515v-.28l1.836-.516v.28zM73.528 6.397l-1.836.517v-.281l1.836-.515v.279z",
    fill: "gray"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.526 4.113h-1.834v.279h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m73.528 4.392-1.836.517v-.28l1.836-.516v.279z",
    fill: "gray"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.547 5.115h-1.834v.28h1.834v-.28zM75.547 5.616h-1.834v.279h1.834v-.28zM75.547 4.613h-1.834v.279h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m75.547 4.894-1.834.515v-.28l1.834-.516v.28z",
    fill: "gray"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75.547 6.118h-1.834v.279h1.834v-.28zM75.547 6.627h-1.834v.28h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m75.547 5.394-1.834.517v-.279l1.834-.517v.28zM75.547 5.897l-1.834.515v-.28l1.834-.516v.28zM75.547 6.397l-1.834.517v-.281l1.834-.515v.279z",
    fill: "gray"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75.547 4.113h-1.834v.279h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m75.547 4.392-1.834.517v-.28l1.834-.516v.279z",
    fill: "gray"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M80.625 4.122a.93.93 0 0 0-.653-.343l-4.066-.308h-4.573l-4.066.308a.93.93 0 0 0-.815 1.223l.298.902h2.963l1.135 1.278a.888.888 0 0 0 .666.3h4.213a.893.893 0 0 0 .666-.3l1.135-1.278h2.963l.297-.902a.93.93 0 0 0-.163-.88zm-9.86 1.302a.218.218 0 0 1-.347.173l-1.056-.8v-.469a.186.186 0 0 1 .186-.186h1.04a.186.186 0 0 1 .185.186l-.007 1.096zm4.912.997a.372.372 0 0 1-.372.372h-3.37a.372.372 0 0 1-.371-.372V4.529a.372.372 0 0 1 .372-.372h3.369a.372.372 0 0 1 .372.372v1.892zm2.195-1.613-1.057.8a.218.218 0 0 1-.348-.173V4.34a.186.186 0 0 1 .186-.186h1.04a.186.186 0 0 1 .186.186l-.007.47z",
    fill: "gray"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.457 5.032h-.97a.195.195 0 0 0-.195.195v.97c0 .107.087.195.195.195h.97a.195.195 0 0 0 .195-.196v-.969a.195.195 0 0 0-.195-.195zM79.754 5.032h-.969a.195.195 0 0 0-.195.195v.97c0 .107.087.195.195.195h.97a.195.195 0 0 0 .195-.196v-.969a.195.195 0 0 0-.196-.195z",
    fill: "#4D4D4D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.946 8.496a3.008 3.008 0 1 0-2.28-5.567 3.008 3.008 0 0 0 2.28 5.567z",
    fill: "gray"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.54 6.157a2.772 2.772 0 1 0-5.47-.892 2.772 2.772 0 0 0 5.47.892z",
    fill: "#4D4D4D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54 7.499a1.93 1.93 0 1 0-1.47-3.572 1.93 1.93 0 0 0 1.47 3.572z",
    fill: "#333"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.806 6.317a.605.605 0 1 0 0-1.21.605.605 0 0 0 0 1.21z",
    fill: "#4D4D4D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.093 6.055a3.008 3.008 0 1 0-5.976-.686 3.008 3.008 0 0 0 5.976.686z",
    fill: "gray"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.858 6.028a2.772 2.772 0 1 0-5.507-.633 2.772 2.772 0 0 0 5.508.633z",
    fill: "#4D4D4D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.035 5.713a1.931 1.931 0 1 1-3.863 0 1.931 1.931 0 0 1 3.863 0z",
    fill: "#333"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 5.712a.604.604 0 1 1-1.209 0 .604.604 0 0 1 1.208 0zM14.363 5.115h-1.835v.28h1.835v-.28zM14.363 5.616h-1.835v.279h1.835v-.28zM14.363 4.613h-1.835v.279h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m14.363 4.894-1.835.515v-.28l1.835-.516v.28z",
    fill: "gray"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M14.363 6.118h-1.835v.279h1.835v-.28zM14.363 6.627h-1.835v.28h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m14.363 5.394-1.835.517v-.279l1.835-.517v.28zM14.363 5.897l-1.835.515v-.28l1.835-.516v.28zM14.363 6.397l-1.835.517v-.281l1.835-.515v.279z",
    fill: "gray"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M14.363 4.113h-1.835v.279h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m14.363 4.392-1.835.517v-.28l1.835-.516v.279z",
    fill: "gray"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16.381 5.115h-1.834v.28h1.834v-.28zM16.381 5.616h-1.834v.279h1.834v-.28zM16.381 4.613h-1.834v.279h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m16.381 4.894-1.834.515v-.28l1.834-.516v.28z",
    fill: "gray"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16.381 6.118h-1.834v.279h1.834v-.28zM16.381 6.627h-1.834v.28h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m16.381 5.394-1.834.517v-.279l1.834-.517v.28zM16.381 5.897l-1.834.515v-.28l1.834-.516v.28zM16.381 6.397l-1.834.517v-.281l1.834-.515v.279z",
    fill: "gray"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16.381 4.113h-1.834v.279h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m16.381 4.392-1.834.517v-.28l1.834-.516v.279z",
    fill: "gray"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21.46 4.122a.932.932 0 0 0-.654-.343l-4.07-.308h-4.568L8.1 3.779a.93.93 0 0 0-.814 1.215l.295.902h2.964l1.134 1.278a.897.897 0 0 0 .666.3h4.215a.897.897 0 0 0 .666-.3l1.135-1.278h2.963l.296-.902a.93.93 0 0 0-.162-.872zM11.6 5.424a.217.217 0 0 1-.347.173l-1.05-.789V4.34a.186.186 0 0 1 .186-.186h1.04a.186.186 0 0 1 .186.186L11.6 5.424zm4.911.997a.372.372 0 0 1-.372.372h-3.37a.372.372 0 0 1-.372-.372V4.529a.372.372 0 0 1 .372-.372h3.37a.372.372 0 0 1 .372.372v1.892zm2.193-1.613-1.056.8a.216.216 0 0 1-.346-.173V4.34a.186.186 0 0 1 .186-.186h1.034a.186.186 0 0 1 .186.186l-.004.47z",
    fill: "gray"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32 5.032h.976a.186.186 0 0 1 .186.186v.97a.186.186 0 0 1-.186.187H8.32a.186.186 0 0 1-.186-.186v-.971a.186.186 0 0 1 .186-.186zM20.59 5.032h-.97a.195.195 0 0 0-.195.195v.97c0 .107.087.195.195.195h.97a.195.195 0 0 0 .195-.196v-.969a.195.195 0 0 0-.196-.195z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.904.93a.266.266 0 0 0 .22-.415.262.262 0 0 0-.466.17c0 .052.016.104.045.148a.259.259 0 0 0 .2.097zM41.966.93a.264.264 0 0 0 .255-.266.275.275 0 0 0-.045-.149.26.26 0 0 0-.463.17c0 .052.016.104.045.148a.257.257 0 0 0 .208.097zM14.358.43h-2.725v.55h2.725V.43zM35.215.43H32.49v.55h2.725V.43z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m84.677 1.479-.93 1.724H4.317l-.919-1.724a.259.259 0 0 1 .236-.36h80.814a.259.259 0 0 1 .229.36z",
    fill: "currentColor"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m71.912 2.15-4.744.915-.448.086-.266.052-5.992 1.155a18.528 18.528 0 0 1-3.521.337H31.138c-1.031 0-2.061-.087-3.078-.259-.149-.024-.296-.052-.445-.08l-5.993-1.155-.266-.052-.447-.086-4.747-.913h55.75z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.14 4.051c-1.142 0-2.28-.11-3.401-.325l-6.055-1.167H4.706l-.432-.794h79.52l-.425.794H66.393l-6.057 1.167c-1.12.216-2.259.325-3.4.325H31.139z",
    fill: "currentColor",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.318 1.12H7.87V3.2h.448V1.12zM15.024 1.12h-.449V3.2h.449V1.12zM21.354 1.12h-.447V3.2h.447V1.12zM28.06 1.12v3.316c-.148-.024-.295-.052-.444-.08V1.12h.445zM34.39 1.12h-.447v3.573h.447V1.12zM41.096 1.12h-.447v3.573h.447V1.12zM47.426 1.12h-.447v3.573h.447V1.12zM54.13 1.12h-.446v3.573h.446V1.12zM60.462 1.12v3.238c-.147.028-.296.056-.444.08V1.12h.444zM67.168 1.12h-.448V3.2h.448V1.12zM73.498 1.12h-.448V3.2h.448V1.12zM80.204 1.12h-.446V3.2h.446V1.12z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatCar);
export default __webpack_public_path__ + "static/media/flat_car.d10c7caf5244f5068be81c6322533923.svg";
export { ForwardRef as ReactComponent };